module.exports = __webpack_public_path__ + "static/media/team_1.ce3e360c.jpg";